export default __webpack_public_path__ + "static/media/favicon.a244110c.ico";